// frontend/src/redux/features/Auth/authThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  requestOtp, 
  verifyOtp, 
  setUsername, 
  tokenRefresh,
  requestPhoneChange,
  verifyPhoneChange
} from "../../../services/authServices";


// ============================================
// 🔐 احراز هویت OTP (ورود)
// ============================================

export const requestOtpThunk = createAsyncThunk(
  "auth/requestOtp",
  async (phone, { rejectWithValue }) => {
    try {
      const response = await requestOtp(phone);
      
      // ✅ اگر کد تست در پاسخ وجود داشت، در کنسول چاپ کن
      if (response.data?.debug_code) {
        console.log(`📱 [DEV] کد تایید برای ${phone}: ${response.data.debug_code}`);
        console.log(`🔗 لینک مستقیم: http://localhost:3000/verify-otp (کد را وارد کنید)`);
      }
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { detail: error.message });
    }
  }
);

export const verifyOtpThunk = createAsyncThunk(
  "auth/verifyOtp",
  async ({ phone, code }, { rejectWithValue }) => {
    try {
      const response = await verifyOtp(phone, code);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { detail: error.message });
    }
  }
);

export const setUsernameThunk = createAsyncThunk(
  "auth/setUsername",
  async ({ first_name, last_name }, { dispatch, getState, rejectWithValue }) => {
    try {
      const { userInfo } = getState().auth;
      const response = await setUsername({ first_name, last_name }, { userInfo, dispatch });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { detail: error.message });
    }
  }
);

export const refreshTokensThunk = createAsyncThunk(
  "auth/refreshTokens",
  async (refresh, { rejectWithValue }) => {
    try {
      const response = await tokenRefresh({ refresh });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { detail: "لطفاً دوباره وارد شوید." });
    }
  }
);


// ============================================
// 📱 تغییر شماره تلفن
// ============================================

export const requestPhoneChangeThunk = createAsyncThunk(
  "auth/requestPhoneChange",
  async (newPhone, { dispatch, getState, rejectWithValue }) => {
    try {
      const { userInfo } = getState().auth;
      const response = await requestPhoneChange(newPhone, { userInfo, dispatch });
      
      // ✅ اگر کد تست در پاسخ وجود داشت، در کنسول چاپ کن
      if (response.data?.debug_code) {
        console.log(`📱 [DEV] کد تایید تغییر شماره برای ${userInfo?.phone}: ${response.data.debug_code}`);
      }
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { detail: error.message });
    }
  }
);

export const verifyPhoneChangeThunk = createAsyncThunk(
  "auth/verifyPhoneChange",
  async (code, { dispatch, getState, rejectWithValue }) => {
    try {
      const { userInfo } = getState().auth;
      const response = await verifyPhoneChange(code, { userInfo, dispatch });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { detail: error.message });
    }
  }
);